var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  clipPath: "url(#layers_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.739.74c.172-.032.35-.032.522 0 .207.039.39.133.465.171l.02.01L18.78 4.94a1 1 0 0 1 0 1.789l-8.036 4.018-.02.01a1.8 1.8 0 0 1-.464.17c-.173.033-.35.033-.522 0a1.8 1.8 0 0 1-.465-.17l-.02-.01L1.22 6.728a1 1 0 0 1 0-1.79L9.256.922l.019-.01C9.35.874 9.533.78 9.74.741"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.772 9.553a1 1 0 0 1 1.342-.448L10 13.05l7.886-3.944a1 1 0 1 1 .895 1.79l-8.036 4.017-.019.01a1.8 1.8 0 0 1-.465.171c-.172.032-.35.032-.522 0a1.8 1.8 0 0 1-.465-.171l-.02-.01-8.034-4.018a1 1 0 0 1-.448-1.341"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.772 13.72a1 1 0 0 1 1.342-.448L10 17.215l7.886-3.943a1 1 0 1 1 .895 1.789l-8.036 4.017-.019.01a1.8 1.8 0 0 1-.465.172c-.172.032-.35.032-.522 0a1.8 1.8 0 0 1-.465-.172l-.02-.01-8.034-4.017a1 1 0 0 1-.448-1.342"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "layers_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h20v20H0z"
})))));
SvgLayers.displayName = "SvgLayers";
export { SvgLayers as ReactComponent };
export default SvgLayers;